export { DMS_MODULE } from '../constants';
export const NAME = 'UzavPokladen';
export const CRUMB_LABEL_KEY = 'setUzavPoklad';
